import { Box } from "@mui/material";
import { Outlet, useParams } from "react-router-dom";
import { LoadingFailedPage, LoadingPage } from "~/components/loading";
import { usePlatformCheck } from "./hooks/usePlatformCheck";
import { PlatformCheckOverview } from "./components/PlatformCheckOverview";
import { PlatformBreadcrumbs } from "../components/PlatformBreadcrumbs";
import {
  TabListItem,
  TabNavigation,
  useRouteMatch,
} from "~/components/tab-nav";

export function PlatformCheckDetailPage() {
  const { policyId } = useParams<{ policyId: string }>();
  const {
    isLoading,
    hasError,
    title,
    check,
    checkScore,
    blastRadius,
    policy,
    lastScannedAt,
    policies,
    findingMrn,
    variants,
    selectedVariant,
    hasVariants,
    searchParams,
    setSearchParams,
  } = usePlatformCheck(policyId);

  if (isLoading) return <LoadingPage what="check details" />;

  if (hasError) return <LoadingFailedPage what="check details" />;

  const breadcrumbItems =
    policyId && policy?.name
      ? [
          {
            label: policy?.name,
            to: `/policies/${encodeURIComponent(policyId)}`,
          },
        ]
      : [];

  // Generate tab href - preserve the findingMrn query param
  const generateHref = (tab: string): string => {
    const basePath = `/policies/${encodeURIComponent(policyId || "")}/check/${tab}`;
    return findingMrn
      ? `${basePath}?findingMrn=${encodeURIComponent(findingMrn)}`
      : basePath;
  };

  const tabList: TabListItem[] = [
    {
      label: "Results",
      to: generateHref("results"),
      route: "/results",
    },
    {
      label: "Remediation",
      to: generateHref("remediation"),
      route: "/remediation",
    },
    // {
    //   label: "Check Details",
    //   to: generateHref("details"),
    //   route: "/details",
    // },
  ];

  const currentTab = useRouteMatch(
    tabList.map((x) => x.route),
    "results",
  );

  return (
    <Box>
      <PlatformBreadcrumbs currentPage={title} items={breadcrumbItems} />
      <PlatformCheckOverview
        title={title}
        isLoading={isLoading}
        check={check}
        checkScore={checkScore}
        blastRadius={blastRadius}
        lastScannedAt={lastScannedAt}
        policies={policies}
      />

      <Box sx={{ px: 5 }}>
        <TabNavigation
          {...{ id: "check-tabs", tabList, currentTab, marginBottom: 3 }}
        />
        <Outlet
          context={{
            findingMrn,
            policyId,
            check,
            checkScore,
            blastRadius,
            variants,
            selectedVariant,
            hasVariants,
            searchParams,
            setSearchParams,
          }}
        />
      </Box>
    </Box>
  );
}
